import axiosInstance from "./AxiosInstance";

export function getCompanyRefundList(data) {
  return axiosInstance.post(`/refund/list`, data);
}

export function updateCompanyRefundStatus(data) {
  return axiosInstance.post(`/refund/status`, data);
}
